import { useApp } from "../contexts/AppContext";
import { getEntityRestriction } from "../lib/permissions";

export function useEntityFilter() {
  const { currentUser } = useApp();
  const restriction = getEntityRestriction(currentUser);

  return {
    // Check if user can view specific entity
    canViewEntity: (entityName: string): boolean => {
      if (restriction.type === "all") return true;
      if (restriction.type === "own") {
        return entityName === restriction.assignedEntity;
      }
      if (restriction.type === "specific") {
        return restriction.entities.includes(entityName);
      }
      return false;
    },

    // Filter array of data by entity field
    filterByEntity: <T extends { entity?: string; location?: string }>(
      data: T[],
    ): T[] => {
      if (restriction.type === "all") return data;

      return data.filter((item) => {
        const itemEntity = item.entity || item.location;
        if (!itemEntity) return true; // Include items without entity

        if (restriction.type === "own") {
          return itemEntity === restriction.assignedEntity;
        }
        if (restriction.type === "specific") {
          return restriction.entities.includes(itemEntity);
        }
        return false;
      });
    },

    // Get list of entities user can see
    getVisibleEntities: (): string[] => {
      if (restriction.type === "all") return ["all"];
      if (restriction.type === "own") {
        return restriction.assignedEntity ? [restriction.assignedEntity] : [];
      }
      if (restriction.type === "specific") {
        return restriction.entities;
      }
      return [];
    },

    // Get restriction info
    restriction,
  };
}
